import { Dispatch, ReactElement, SetStateAction } from 'react';
import Integration from './Integration';

export { Auth } from './AuthModel';
export { default as Farm } from './Farm';
export { default as Field } from './Field';
export { default as IntegrationsModel } from 'views/Integrations/IntegrationsModel';
export { default as Organization } from './Organization';

export enum BubbleUpCase {
  CHECKED_FIELD = 'CHECKED_FIELD',
  SET_HISTOGRAM = 'SET_HISTOGRAM',
  CLICKED_FIELD = 'CLICKED_FIELD',
}

export enum BubbleDownCase {
  ORG_ID_CHANGE,
  USER_ID_CHANGE,
}

export type Token = {
  access_token: string;
  refresh_token: string;
  expires_in: string;
  token_created?: string;
};

export type Option<T> = {
  label: string;
  value: T;
};

export type KeyAndLabel<T> = {
  key: T;
  label: string;
};

export type NameAndId = {
  name: string;
  id: string;
};

export type CropwiseNotification = {
  type?: string;
  referenceId?: string;
  message: string;
  description: string;
  placement: string;
};

export type DatabusNotification = {
  message: string;
  description: string | ReactElement;
  placement: string;
  element_description?: ReactElement;
  type?: string;
  origin?: string;
  button?: any;
  button_text?: string;
  duration?: number;
  referenceId?: string;
};

export type OperationLegendOptions = {
  user_id: string;
  org_id: string;
  operation_id: string;
  dtr_code: string;
  partner?: string;
};

export type DeepAction = {
  org_id: string;
  callback_uri: string;
  state: string | null;
};

export type DeepActionResult = 'CANCELED' | 'SUCCESS' | 'FAILURE';

export type WizardStepsData = { [key: string]: any };

export type WizardStepProps = {
  step: WizardStep;
  integration: Integration | null | undefined;
  accessToken: string | undefined;
  setDisableNextBtn: Function;
  setDisablePrevBtn: Function;
  prevBtnClicked?: boolean;
  wizardData: WizardStepsData;
  onConfigure?: (autoFft: boolean) => void;
  importChecked?: boolean;
  setImportChecked?: Dispatch<SetStateAction<boolean>>;
};

export enum WizardTypes {
  ORGANIZATIONS = 'ORGANIZATIONS',
  DEVICES = 'DEVICES',
  USERS = 'USERS',
  FARMS = 'FARMS',
}

export enum SETTINGS_ACTION {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export type AuthAccountResponse = {
  user_id: string;
  org_id: string;
  partner: string;
  settings: Object;
  auth_config: {
    access_token?: string;
  };
  error_type?: string;
};

export type WizardStep = {
  stepOrder: number;
  name: string;
  subTitle?: string;
  itemDisplayName?: string;
  component?: React.FunctionComponent<WizardStepProps>;
  disabled?: boolean;
  type?: WizardTypes;
  gridColSize?: number;
  importFutureItems?: boolean;
  callFunction?: string;
  selectAll: boolean;
  jobFrequency?: JOB_FREQUENCY;
  specialId?: string;
};

export type WizardCallParams = {
  partnerId: string;
  accessToken: any;
  wizardData: WizardStepsData;
  settings?: { [key: string]: any };
  step: WizardStep;
  action?: string;
  item?: { [key: string]: any };
};

export type SencropDevicesResponse = {
  devices: { [key: string]: any };
  devicesStatuses: {};
  items: number[];
  total: number;
  models: {};
  organisations: {};
  places: {};
  users: {};
};

export type GroGruSitesResponse = {
  status: number;
  data: {
    children: {
      objectId: string;
      name: string;
      sites: {
        siteId: string;
        name: string;
        id: string;
        farm: {
          objectId: string;
        };
        idOrg?: string;
      }[];
    }[];
  };
};

export type PesslStation = {
  id?: string;
  name: {
    original: string;
  };
};

export type VerisChildUser = {
  id?: string;
  Username: string;
  Info: {
    Name: string;
  };
};

export type VerisUsersResponse = {
  Error: string;
  Message: string;
  SessionId: string;
  ChildUsers: VerisChildUser[];
};

export type VerisFilterSetting = {
  grower: string;
  farms: string[];
};

export type VerisFarmsResponse = {
  Error: string;
  Message: string;
  SessionId: string;
  Farms: string[];
};

export type VerisFarm = {
  id: string;
  grower: string;
};

export type VerisFarmAuthAccount = {
  grower: string;
  farms?: string[];
};

export type ArableDevice = {
  id: string;
  orgId: string;
  name: string;
};

export type ArableDevicesResponse = {
  limit: number;
  total: number;
  page: number;
  pages: number;
  items: ArableDevice[];
};

export type MasterlistProductsParams = {
  org_id: string;
  source?: string | undefined;
  country?: string | undefined;
};

export type ValencoDevice = {
  id:
    | {
        id: any;
      }
    | string;
};

export type ValencoDevicesResponse = {
  data: ValencoDevice[];
  totalPages: number;
  totalElements: number;
  hasNext: boolean;
};

export type AgFinitiGrowers = {
  growers: string[];
};

export type JOB_FREQUENCY = 'DAILY' | 'HOURLY';

export type FarmobileOrganizationsResponse = {
  organizations: FarmobileOrganizations[];
};

export type FarmobileOrganizations = {
  company_fmid: string;
  name: string;
};

export type oAuthParams = {
  apiUrl?: string;
  params: {
    redirect_url?: string;
    response_type: string;
    client_id?: string;
    [key: string]: any;
  };
};
